/* eslint-disable no-undef */
let API_URL;
let AUTH_URL;
let RESOURCE_IMAGE_URL;

if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
  API_URL = 'https://api.bline.io';
  RESOURCE_IMAGE_URL = 'https://storage.googleapis.com/images-bline-io/media/';
} else if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
  API_URL = 'https://api-dev-go.bline.io';
  RESOURCE_IMAGE_URL = 'https://storage.googleapis.com/images-dev.bline.io/media/';
} else if (process.env.REACT_APP_ENVIRONMENT === 'local') {
  API_URL = 'http://localhost:4000';
  AUTH_URL = 'http://localhost:7001';
  RESOURCE_IMAGE_URL = 'https://storage.googleapis.com/images-dev.bline.io/media/';
} else if (process.env.REACT_APP_ENVIRONMENT === 'stage') {
  API_URL = 'https://api-dev-go.bline.io';
  RESOURCE_IMAGE_URL = 'https://storage.googleapis.com/images-dev.bline.io/media/';
}

export default { API_URL, AUTH_URL, RESOURCE_IMAGE_URL };
